/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/play';
import { PLAY } from '@/store/types';
import { equals } from '@/utils/util';
import { PlayService } from '@/api/types/play';

export interface StorePlayServiceRecommendState {
  engine: string;
  engineVal: string;
  sort: string;
  page: number;
  gender: number;
  filter: Record<string, string>;
  list: PlayService[];
  noMore: boolean;
  updateTime: number;
  lock: boolean;
}

export default {
  namespaced: true,
  state: {
    engine: null,
    engineVal: null,
    sort: null,
    page: 0,
    gender: null,
    filter: {},
    list: [],
    noMore: null,
    updateTime: null,
    lock: null,
  },
  getters: {
    engine(state) {
      return state.engineVal || state.engine;
    },
  },
  actions: {
    [PLAY.GET_SERVICE_LIST](
      { state, commit },
      { engine, sort, gender, filter: filterData = {}, reload, more, force, silent }: {
        engine: string;
        sort: string;
        gender: number;
        filter: Record<string, string | string[]>;
        reload: boolean;
        more: boolean;
        force: boolean;
        silent: boolean;
      },
    ) {
      const filter: Record<string, string> = {};
      Object.entries(filterData).forEach(([k, v]) => {
        const sv = v instanceof Array ? v.join(',') : v;
        if (sv) {
          filter[k] = sv;
        }
      });
      filter.kw = 'recommend';
      if (state.engine !== engine || state.sort !== sort || state.gender !== gender
        || !equals(state.filter, filter, { ignoreValues: [void 0, null] })) {
        reload = true;
      }
      if (state.noMore && !force) {
        more = false;
      }
      if ((reload || more) && !state.lock) {
        commit(PLAY.GET_SERVICE_LIST, { action: 'start' });
        const page = reload ? 1 : state.page + 1;
        return new Promise((resolve, reject) => {
          const params = { sort, page, gender, filter };
          Object.entries(filter).forEach(([k, v]) => {
            params[`filter[${k}]`] = v;
          });
          api.getServices(engine, params, silent).then((res) => {
            commit(PLAY.GET_SERVICE_LIST, {
              action: 'success',
              reload,
              engine,
              sort,
              page,
              gender,
              filter,
              data: res.data,
              engineVal: res.extra.engine,
              pageCount: res.extra.pageCount,
            });
            resolve();
          }).catch((err) => {
            commit(PLAY.GET_SERVICE_LIST, { action: 'failed' });
            reject(err);
          });
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [PLAY.GET_SERVICE_LIST](state, { action, reload, engine, sort, page, gender, filter, data, engineVal, pageCount }) {
      if (action === 'start') {
        state.lock = true;
      } else {
        if (action === 'success') {
          state.engine = engine;
          state.sort = sort;
          state.page = page;
          state.gender = gender;
          state.filter = filter;
          state.list = reload || page === 0 ? data : state.list.concat(data);
          state.engineVal = engineVal;
          state.noMore = page >= pageCount;
          state.updateTime = new Date().valueOf();
        }
        state.lock = false;
      }
    },
  },
};
